/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/EuropeanHealthInsuranceCardTypes.yaml
import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../utils/utils';
/**
The result of the health insurance card recognition.
*/
export class EuropeanHealthInsuranceCardRecognitionResult extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<EuropeanHealthInsuranceCardRecognitionResult>`} */
    constructor(source = {}) {
        super();
        /**
          Recognition status.
          
          Default is FAILED_DETECTION
          */
        this.status = 'FAILED_DETECTION';
        if (source.fields !== undefined) {
            this.fields = source.fields.map((it) => {
                return new EuropeanHealthInsuranceCardRecognitionResult.Field(it);
            });
        }
        else {
            throw new Error('fields must be present in constructor argument');
        }
        if (source.status !== undefined) {
            this.status = source.status;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            fields: this.fields.map((it) => {
                return it.serialize(config);
            }),
            status: this.status,
        };
    }
}
(function (EuropeanHealthInsuranceCardRecognitionResult) {
    EuropeanHealthInsuranceCardRecognitionResult.RecognitionStatusValues = ['SUCCESS', 'FAILED_DETECTION', 'INCOMPLETE_VALIDATION'];
    /**
      Health insurance card field.
      */
    class Field extends PartiallyConstructible {
        /** @param source {@displayType `DeepPartial<Field>`} */
        constructor(source = {}) {
            super();
            /**
                Field validation status.
                
                Default is NOT_VALIDATED
                */
            this.validationStatus = 'NOT_VALIDATED';
            if (source.type !== undefined) {
                this.type = source.type;
            }
            else {
                throw new Error('type must be present in constructor argument');
            }
            if (source.value !== undefined) {
                this.value = source.value;
            }
            else {
                throw new Error('value must be present in constructor argument');
            }
            if (source.confidence !== undefined) {
                this.confidence = source.confidence;
            }
            else {
                throw new Error('confidence must be present in constructor argument');
            }
            if (source.validationStatus !== undefined) {
                this.validationStatus = source.validationStatus;
            }
        }
        serialize(config = new ToJsonConfiguration()) {
            return {
                type: this.type,
                value: this.value,
                confidence: this.confidence,
                validationStatus: this.validationStatus,
            };
        }
    }
    EuropeanHealthInsuranceCardRecognitionResult.Field = Field;
    (function (Field) {
        Field.ValidationStatusValues = ['NOT_VALIDATED', 'FAILURE', 'SUCCESS', 'CONFIRMED'];
        Field.FieldTypeValues = [
            'SURNAME',
            'GIVEN_NAME',
            'DATE_OF_BIRTH',
            'PERSONAL_IDENTIFICATION_NUMBER',
            'INSTITUTION_NUMBER',
            'INSTITUTION_NAME',
            'CARD_NUMBER',
            'CARD_EXPIRATION_DATE',
            'COUNTRY',
        ];
    })(Field = EuropeanHealthInsuranceCardRecognitionResult.Field || (EuropeanHealthInsuranceCardRecognitionResult.Field = {}));
})(EuropeanHealthInsuranceCardRecognitionResult || (EuropeanHealthInsuranceCardRecognitionResult = {}));
/**
Configuration for the European health insurance card (EHIC) recognizer.
*/
export class EuropeanHealthInsuranceCardRecognizerConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<EuropeanHealthInsuranceCardRecognizerConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          List of allowed countries for the EHIC. If:
          - single country: validation rules for the given country are used starting from the first
                          frame. If the country cannot be inferred or the inferred country doesn't
                          match the given country, the result of recognize() will be IncompleteValidation.
          - multiple countries: the country is inferred from the card number first.
                          Until the country is detected, the document fields are not OCR'd and
                          accumulated. Once the country is inferred, the field accumulation starts
                          and the inferred country validation rules are applied.
                          If the country cannot be inferred or the inferred country doesn't match
                          any of the countries in the list, the result status will be IncompleteValidation.
          - empty list: same as "multiple countries" with one additional detail.
          
          If the country cannot be inferred within `maxCountryDetectionAttempts` successive frames in which the
          part of the card number that stores the country code was successfully OCR'd, then the country is
          inferred to be Unknown and no validation rules are applied. Field accumulation then proceeds normally.
          In this case recognize() can eventually return Success and the document will have a CountryType of Unknown.
          */
        this.allowedCountries = [];
        /**
          Minimum year of birth.
          
          Default is 0
          */
        this.minBirthYear = 0;
        /**
          Maximum year of birth.
          
          Default is 2999
          */
        this.maxBirthYear = 2999;
        /**
          Minimum card expiration year.
          
          Default is 0
          */
        this.minExpirationYear = 0;
        /**
          Maximum card expiration year.
          
          Default is 2999
          */
        this.maxExpirationYear = 2999;
        /**
          Maximum number of attempts before giving up on country detection. After the specified number of
          attempts, the country field is considered to be unknown and validation is skipped.
          This option is ignored if allowedCountries is not empty.
          
          Default is 5
          */
        this.maxCountryDetectionAttempts = 5;
        /**
          Minimum number of accumulated frames that should have equal result for a field.
          Once satisfied, the corresponding field is considered to be successfully-recognized and won't be considered in the subsequent frames.
          
          Default is 4
          */
        this.minEqualFrameCount = 4;
        /**
          Maximum number of partial frame results to keep in cache while waiting to gather minEqualFrameCount equal results.
          
          Default is 10
          */
        this.maxAccumulatedFrameCount = 10;
        if (source.allowedCountries !== undefined) {
            this.allowedCountries = source.allowedCountries.map((it) => {
                return it;
            });
        }
        if (source.minBirthYear !== undefined) {
            this.minBirthYear = source.minBirthYear;
        }
        if (source.maxBirthYear !== undefined) {
            this.maxBirthYear = source.maxBirthYear;
        }
        if (source.minExpirationYear !== undefined) {
            this.minExpirationYear = source.minExpirationYear;
        }
        if (source.maxExpirationYear !== undefined) {
            this.maxExpirationYear = source.maxExpirationYear;
        }
        if (source.maxCountryDetectionAttempts !== undefined) {
            this.maxCountryDetectionAttempts = source.maxCountryDetectionAttempts;
        }
        if (source.minEqualFrameCount !== undefined) {
            this.minEqualFrameCount = source.minEqualFrameCount;
        }
        if (source.maxAccumulatedFrameCount !== undefined) {
            this.maxAccumulatedFrameCount = source.maxAccumulatedFrameCount;
        }
    }
}
//# sourceMappingURL=EuropeanHealthInsuranceCardTypes.js.map